<template>
    <button class="alexa-rank" @click="orderByAlexaRank">
        <Icon icon="rank-yellow" class="yellow-sign"/>
        Alexa Rank
        <div class="arrows">
            <Icon :icon="alexaRankOrder === 'desc' ? 'purple-arrow-down' : 'gray-arrow-down'"/>
            <Icon :icon="alexaRankOrder === 'asc' ? 'purple-arrow-down' : 'gray-arrow-down'"/>
        </div>
    </button>
</template>

<script>
import { ref, onMounted, watch } from '@vue/composition-api'
import {useRouter} from '../../../../core/hooks'
import Icon from '../../../Theme/Icon.vue'


export default {
    name: 'OrderBy',
    components: {
        Icon
    },
    setup(props, {emit, root}) {
        const alexaRankOrder = ref(null)
        const {route} = useRouter()

        watch(route, route => {
            if(!route.query.filters) {
                alexaRankOrder.value = null
            }
        })

        onMounted(() => {
            if(route.value.query.filters) {
                const filters = JSON.parse(route.value.query.filters)
                alexaRankOrder.value = filters.alexaRankOrder || null
                emit('onOrder', alexaRankOrder.value)
            }
        })

        const orderByAlexaRank = () => {
            switch(alexaRankOrder.value){
                case null:
                    alexaRankOrder.value = 'desc'
                    break;
                case 'desc':
                    alexaRankOrder.value = 'asc'
                    break;
                case 'asc':
                    alexaRankOrder.value = null
            }
            emit('onOrder', alexaRankOrder.value)
        }

        return { 
            alexaRankOrder, 
            orderByAlexaRank
        }
    },
}
</script>

<style lang="scss" scoped>
$border: 1px solid #CBD5E0;
$button_color: #718096;
$button_fontsize: 16px;
$button_lineheight: 24px;
$button_padding: 8px 16px;
$button_radius: 8px;
.alexa-rank {
    display: flex;
    margin-right: 16px;
    padding: $button_padding;
    font-size: $button_fontsize;
    color: $button_color;
    line-height: $button_lineheight;
    border: $border;
    min-width: 200px;
    border-radius: $button_radius;
    .yellow-sign {
        margin-right: 12px;
    }
    .arrows {
        margin-left: 12px;
        img:last-child {
            transform: rotate(180deg)
        }
        img.active {
            filter: brightness(0.6)
        }
    }
}
</style>